import type { ConsoleScreenMap } from '../types'
import { lazyScreen } from '../lazyScreen'
const ParentConsole = lazyScreen(() => import('./ParentConsole'), (m) => m.ParentConsole)

/**
 * The parent tier's redesigned screens, by route. A route listed here is served
 * by the console registry ahead of AppRouter's older switch. Owned by the
 * parent workstream.
 *
 * 🔴 EVERY PARENT ROUTE IS THE SAME COMPONENT. `ParentConsole` holds the active
 * child; registering one component for all six keeps it mounted across tabs, so
 * a parent of two who picked the second child on Progress is still looking at
 * that child on Attendance. Privacy & consent (M9) is `#/parent?view=privacy` —
 * ADR-051 removed the separate route, so it is a sub-view of Home.
 *
 * `adaptive`: a bottom tab bar on a phone, the sidebar on a wider screen.
 */
const screen = { component: ParentConsole, nav: 'adaptive' as const, contentMaxWidthClass: 'max-w-[64rem]' }

export const PARENT_SCREENS: ConsoleScreenMap = {
  parent: screen,
  'parent-reports': screen,
  'parent-attendance': screen,
  'parent-messages': screen,
  'parent-achievements': screen,
  'parent-announcements': screen,
}
